import { BLOB_FOLDERS } from '@constants/Azure'

const decodeBase64Url = (value: string): string => {
  const padded = value.replace(/-/g, '+').replace(/_/g, '/')
  const pad = padded.length % 4 === 0 ? '' : '='.repeat(4 - (padded.length % 4))
  return atob(padded + pad)
}

const blobNameFromLegacyStreamToken = (token: string): string => {
  try {
    const parsed = JSON.parse(decodeBase64Url(token)) as { b?: unknown }
    return typeof parsed.b === 'string' ? parsed.b : ''
  } catch {
    return ''
  }
}

export const isCanonicalCallRecordingBlobName = (
  value?: string | null,
): boolean => {
  if (!value) return false
  if (/^https?:\/\//i.test(value)) return false
  const path = value.split('?')[0] ?? ''
  return (
    path.includes(`/${BLOB_FOLDERS.CALL_RECORDINGS}/`) &&
    /\.(e\.)?mp3$/i.test(path)
  )
}

export const recordingBlobNameFromRef = (value?: string | null): string => {
  if (!value) return ''
  if (isCanonicalCallRecordingBlobName(value))
    return value.split('?')[0] ?? value

  try {
    if (value.includes('/recordings/stream')) {
      const parsed = new URL(value, 'http://localhost')
      const fromQuery = parsed.searchParams.get('b')
      if (fromQuery) return decodeURIComponent(fromQuery)
      const fromToken = blobNameFromLegacyStreamToken(
        parsed.searchParams.get('token') ?? '',
      )
      if (fromToken) return fromToken
    }

    if (/^https?:\/\//i.test(value)) {
      const parsed = new URL(value.split('?')[0] ?? value)
      const parts = parsed.pathname
        .split('/')
        .filter(Boolean)
        .map((segment) => decodeURIComponent(segment))
      if (parts.length >= 2) {
        const rest = parts.slice(1).join('/')
        if (rest.includes(`/${BLOB_FOLDERS.CALL_RECORDINGS}/`)) return rest
      }
    }
  } catch {
    return ''
  }

  return ''
}

export const needsRecordingCanonicalize = (value?: string | null): boolean =>
  Boolean(value?.trim()) && !recordingBlobNameFromRef(value)

export const triggerRecordingDownload = (
  objectUrl: string,
  callId: string,
): void => {
  const link = document.createElement('a')
  link.href = objectUrl
  link.download = `call-recording-${callId}.mp3`
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
